import SubmitContext from 'context/submit/submitContext'
import React, { useContext, useEffect, useState } from 'react'
import Switch from 'react-switch'
import {
  Col,
  FormGroup,
  Input,
  Row,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Alert,
} from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { isComma } from 'context/Utilities'
import PropTypes from 'prop-types'

const ProductDesc = ({ brandSpecific = false }) => {
  const submitContext = useContext(SubmitContext)

  const { current } = submitContext

  const [description, setDescription] = useState({
    UPC: '',
    brandName: '',
    productName: '',
    Manufacturer: '',
    distbInCA: false,
    RetailPrice: '',
    FederalNutrition: false,
  })

  useEffect(() => {
    if (current !== null) {
      const {
        UPC,
        brandName,
        productName,
        Manufacturer,
        distbInCA,
        RetailPrice,
        FederalNutrition,
      } = current
      setDescription({
        UPC: UPC ?? '',
        brandName: brandName ?? '',
        productName: productName ?? '',
        Manufacturer: Manufacturer ?? '',
        distbInCA: distbInCA ?? false,
        RetailPrice: RetailPrice ?? '',
        FederalNutrition: FederalNutrition ?? false,
      })
    }
    console.log('current: ' + JSON.stringify(current))
    // eslint-disable-next-line
  }, [current])

  const { onChange, setSwitch, asterisk } = useFormUtils()

  const methods = useFormContext()

  return (
    <Row>
      <Col xs={2}>
        <FormGroup>
          <p>
            <strong>UPC {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="UPC"
            control={methods.control}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
            onKeyDown={e => {
              if (
                ![
                  'Backspace',
                  'Delete',
                  'Tab',
                  'ArrowLeft',
                  'ArrowRight',
                  'Control',
                  'Meta',
                ].includes(e.key) &&
                isNaN(parseInt(e.key)) &&
                !(e.ctrlKey || e.metaKey) // Allow copy-paste shortcuts
              ) {
                e.preventDefault()
              }
            }}
            onInput={e => {
              e.target.value = e.target.value.replace(/\D/g, '') // Remove non-numeric characters
            }}
            rules={{
              required: true,
              validate: {
                length: UPC => [8, 12, 13].includes(UPC.length),
                allZeros: UPC =>
                  !['00000000', '000000000000', '0000000000000'].includes(UPC),
              },
            }}
          />
          <p className={'text-danger'}>
            {methods.errors.UPC && methods.errors.UPC.type === 'required' && (
              <Alert color="danger" className={'mt-3'}>
                ⚠ UPC is required.
              </Alert>
            )}
            {methods.errors.UPC && methods.errors.UPC.type === 'length' && (
              <Alert color="danger" className={'mt-3'}>
                ⚠ UPC must be 8, 12, or 13 digits.
              </Alert>
            )}
            {methods.errors.UPC && methods.errors.UPC.type === 'allZeros' && (
              <Alert color="danger" className={'mt-3'}>
                ⚠ UPC must not consist of all zeros.
              </Alert>
            )}
          </p>
        </FormGroup>
      </Col>
      <Col xs={4}>
        <FormGroup>
          <p>
            <strong>Manufacturer</strong>
          </p>
          <Controller
            as={<Input value={description.Manufacturer} />}
            name="Manufacturer"
            control={methods.control}
            onKeyDown={e => {
              if (isComma(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
            rules={{
              maxLength: 20,
            }}
          />
          <p className={'text-danger'}>
            {methods.errors.Manufacturer &&
              methods.errors.Manufacturer.type === 'maxLength' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Manufacturer exceeds 20 characters.
                </Alert>
              )}
          </p>
        </FormGroup>
      </Col>
      <Col xs={3}>
        <FormGroup>
          <p>
            <strong>Brand Name {asterisk}</strong>
          </p>
          <Controller
            as={<Input value={description.brandName} />}
            name="brandName"
            control={methods.control}
            onKeyDown={e => {
              if (isComma(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
            rules={{
              required: true,
              maxLength: 25,
            }}
          />

          <p className={'text-danger'}>
            {methods.errors.brandName &&
              methods.errors.brandName.type === 'required' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Brand name is required.
                </Alert>
              )}
            {methods.errors.brandName &&
              methods.errors.brandName.type === 'maxLength' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Brand name exceeds 25 characters.
                </Alert>
              )}
          </p>
        </FormGroup>
      </Col>
      <Col xs={3}>
        <FormGroup>
          <p>
            <strong>Product Name {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="productName"
            control={methods.control}
            onKeyDown={e => {
              if (isComma(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
            rules={{
              required: true,
              maxLength: 50,
            }}
          />
          <p className={'text-danger'}>
            {methods.errors.productName &&
              methods.errors.productName.type === 'required' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Product name is required.
                </Alert>
              )}
            {methods.errors.productName &&
              methods.errors.productName.type === 'maxLength' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Product name exceeds 50 characters.
                </Alert>
              )}
          </p>
        </FormGroup>
      </Col>
      <Col xs={4}>
        <FormGroup>
          <p>
            <strong>
              I verify that this product is distributed in California.{' '}
              {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="distbInCA"
            id="distbInCA"
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            control={methods.control}
            defaultValue={description.distbInCA}
            rules={{ validate: distbInCA => distbInCA === true }}
          />
          <br />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="distbInCA"
              message={'⚠ Product must be distributed in CA.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <FormGroup>
          <p>
            <strong>
              I certify that this product meets the federal minimum requirements
              listed in 7 CFR part 246.10(e)(12), table 4. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="FederalNutrition"
            id="FederalNutrition"
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            control={methods.control}
            defaultValue={description.FederalNutrition}
            rules={{ validate: FederalNutrition => FederalNutrition === true }}
          />
          <br />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="FederalNutrition"
              message={'⚠ Product must meet federal nutrition levels.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={4}>
        <FormGroup>
          <p>
            <strong>
              Suggested Retail Price Per Unit {brandSpecific && asterisk}
            </strong>
          </p>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>$</InputGroupText>
            </InputGroupAddon>
            <Controller
              as={Input}
              name="RetailPrice"
              type="number"
              max="999.99"
              step="0.01"
              control={methods.control}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
              onKeyDown={e => {
                if (
                  ![
                    'Backspace',
                    'Delete',
                    'Tab',
                    '.',
                    'ArrowLeft',
                    'ArrowRight',
                  ].includes(e.key) &&
                  isNaN(parseInt(e.key))
                ) {
                  e.preventDefault()
                }
              }}
              placeholder={'Retail Price'}
              rules={{
                maxLength: 6,
                min: 0,
                required: brandSpecific,
              }}
            />
          </InputGroup>
          <p className={'text-danger'}>
            {methods.errors.RetailPrice &&
              methods.errors.RetailPrice.type === 'maxLength' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Retail price exceeds 6 characters.
                </Alert>
              )}
            {methods.errors.RetailPrice &&
              methods.errors.RetailPrice.type === 'min' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Retail price must be zero or greater.
                </Alert>
              )}
            {methods.errors.RetailPrice &&
              methods.errors.RetailPrice.type === 'required' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Retail Price is required.
                </Alert>
              )}
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

ProductDesc.propTypes = {
  brandSpecific: PropTypes.bool,
}

export default ProductDesc
